import { render, staticRenderFns } from "./TreatmentSessionProcedureSummary.vue?vue&type=template&id=7952c865"
import script from "./TreatmentSessionProcedureSummary.vue?vue&type=script&lang=js"
export * from "./TreatmentSessionProcedureSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports